export default __webpack_public_path__ + "static/media/f14.06d01681.jpg";